import { PERMISSIONS } from 'api/auth/constants';
import { TObject } from 'utils/types';

import { IPermission, IPermissionData, IPermissionPicture, IRole } from './types';

type IRolesData = TObject & {
  permissions: string[];
};

export const normalizePermissionName = (permission: string): string => {
  const normalName = permission.toLowerCase().split(/[.-_]/).join(' ');
  const readableName = normalName.charAt(0).toUpperCase() + normalName.slice(1);

  return readableName;
};

export const normalizePermission = (permission: IPermissionData): IPermission => {
  return {
    label: normalizePermissionName(permission.permission),
    pictureExist: permission.pictureExist,
    value: permission.permission as PERMISSIONS,
  };
};

export const normalizeRolePermission = (permission: string): IPermission => {
  return {
    label: normalizePermissionName(permission),
    value: permission as PERMISSIONS,
  };
};
export const normalizeRole = (data: IRolesData): IRole => {
  return {
    created: (data?.created as string) || '',
    id: (data?.id as string) || '',
    permissions: data?.permissions?.map(normalizeRolePermission) || [],
    role: (data?.role as string) || '',
    usersCount: (data?.usersCount as number) || 0,
  };
};

export const normalizePermissionPicture = (data: TObject): IPermissionPicture => {
  return {
    picture: (data?.picture as string) || null,
    pictureDescription: (data?.pictureDescription as string) || null,
  };
};
